import React, { useContext } from 'react';
import ConfirmRow from '../components/confirmRow';
import { CustomizeContext } from '../contexts/customize';
import Button from '../common/button';
import embroideryImage from '../../assets/placement.png';
import embroiderySpImage from '../../assets/placement-sp.png';
import cautionImg from '../../assets/caution.png';
import { toInch } from '../lib/size';

const CustomizeConfirm = ({ onClickReturn, popup, setPopup }) => {
  const { customizes } = useContext(CustomizeContext);
  const hrMainStyle = {
    border: '2px solid #062D3B',
    opacity: 1,
    marginTop: '40px'
  };
  const dataset = document.getElementById('mtm-customize').dataset;
  const fabricName = dataset.mtmCloth;
  const fabricImg = dataset.mtmClothImg;
  const bodyName = dataset.mtmBody;
  const buttonDownCollar = dataset.mtmButtonDownCollar;

  const checkQueue = (order) => {
    order.items.shift();
    if (order.items.length) {
      orderItems(order);
    } else {
      window.location.href = '/cart';
    }
  };

  const orderItems = (order) => {
    if (!order.items.length) {
      return;
    }
    if (!order.items[0].available) {
      alert('This product is currently unavailable for purchase.');
      return;
    }
    var properties = order.items[0].properties;
    var request = new XMLHttpRequest();
    request.open('post', '/cart/add.js', true);
    request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        checkQueue(order);
      } else {
        alert('This product is currently unavailable for purchase.');
      }
    };
    request.onerror = () => {
      'error2';
    };
    request.send(
      JSON.stringify({
        quantity: order.items[0].quantity,
        id: order.items[0].id,
        properties
      })
    );
  };

  const addCart = () => {
    setPopup(false);

    const variants = document.getElementById('mtm-customize').dataset.variants;
    const variant = JSON.parse(variants);
    const order = {
      items: [
        {
          id: variant[0].id,
          quantity: 1,
          available: true,
          properties: {
            _reorder_id: '',
            ['_collar_' + customizes.collar.id + '_' + customizes.collar.value]: customizes.collar.label,
            [customizes.collar.cleric_type.id
              ? '_cleric_type_' + customizes.collar.cleric_type.id + '_' + customizes.collar.cleric_type.value
              : '_cleric_type'
            ]: 
              customizes.collar.cleric_type.label
              ? customizes.collar.cleric_type.label
              : '',
            ['_back_' + customizes.back.id + '_' + customizes.back.value]: customizes.back.label,
            ['_cuffs_' + customizes.cuffs.id + '_' + customizes.cuffs.value]: customizes.cuffs.label,
            [customizes.cuffs.cuffs_type.id
              ? '_cuffs_type_' + customizes.cuffs.cuffs_type.id + '_' + customizes.cuffs.cuffs_type.value
              : '_cuffs_type'
            ]: 
              customizes.cuffs.cuffs_type.label
              ? customizes.cuffs.cuffs_type.label
              : '',
            ['_plackets_' + customizes.plackets.id + '_' + customizes.plackets.value]: customizes.plackets.label,
            ['_pocket_' + customizes.pocket.id + '_' + customizes.pocket.value]: customizes.pocket.label,
            ['_button_' + customizes.button.id + '_' + customizes.button.value]: customizes.button.label,
            ['_base_size_' + customizes.sizes.base.id]:
              customizes.sizes.base.label,
            ['_chest_size_' + customizes.sizes.chest_size.id + '_' + customizes.sizes.chest_size.value]:
              customizes.sizes.chest_size.label,
            ['_collar_size_' + customizes.sizes.collar_size.id + '_' + customizes.sizes.collar_size.value]:
              customizes.sizes.collar_size.label,
            ['_body_length_' + customizes.sizes.body_length.id + '_' + customizes.sizes.body_length.value]:
              customizes.sizes.body_length.label,
            ['_sleeve_length_left_' + customizes.sizes.sleeve_length_left.id + '_' + customizes.sizes.sleeve_length_left.value]:
              customizes.sizes.sleeve_length_left.label,
            ['_sleeve_length_right_' + customizes.sizes.sleeve_length_right.id + '_' + customizes.sizes.sleeve_length_right.value]:
              customizes.sizes.sleeve_length_right.label,
            ['_cuffs_width_left_' + customizes.sizes.cuffs_width_left.id + '_' + customizes.sizes.cuffs_width_left.value]:
              customizes.sizes.cuffs_width_left.label,
            ['_cuffs_width_right_' + customizes.sizes.cuffs_width_right.id + '_' + customizes.sizes.cuffs_width_right.value]:
              customizes.sizes.cuffs_width_right.label,
            ['_waist_size_' + customizes.sizes.waist_size.id + '_' + customizes.sizes.waist_size.value]:
              customizes.sizes.waist_size.label,
            ['_yoke_size_' + customizes.sizes.yoke_size.id + '_' + customizes.sizes.yoke_size.value]:
              customizes.sizes.yoke_size.label,
            ['_sleeve_width_' + customizes.sizes.sleeve_width.id + '_' + customizes.sizes.sleeve_width.value]:
              customizes.sizes.sleeve_width.label,
            ['_embroidery']:
              customizes.embroideryOptions.embroidery.value,
            ['_embroidery_colors_' + customizes.embroideryOptions.embroidery_color.id]:
              customizes.embroideryOptions.embroidery_color.value
              ? customizes.embroideryOptions.embroidery_color.value
              : '',
            ['_embroidery_type_' + customizes.embroideryOptions.embroidery_type.id]: 
              customizes.embroideryOptions.embroidery_type.value
              ? customizes.embroideryOptions.embroidery_type.value
              : '',
            ['_embroidery_place_' + customizes.embroideryOptions.embroidery_place.id]:
              customizes.embroideryOptions.embroidery_place.value
              ? customizes.embroideryOptions.embroidery_place.value
              : '',
            ['_embroidery_format_' + customizes.embroideryOptions.embroidery_format.id]: 
              customizes.embroideryOptions.embroidery_format.value
              ? customizes.embroideryOptions.embroidery_format.value
              : '',
            ['_embroidery_initial']: 
              customizes.embroideryOptions.embroidery_initial.value
              ? customizes.embroideryOptions.embroidery_initial.value
              : '',
            ['_brand_name_' + customizes.brand_name.id + '_' + customizes.brand_name.value]: customizes.brand_name.label
              ? customizes.brand_name.label
              : '',
            ['_kamakura_name_' + customizes.kamakura_name.id + '_' + customizes.kamakura_name.value]: customizes.kamakura_name.label
              ? customizes.kamakura_name.label
              : ''
          }
        }
      ]
    };
    orderItems(order);
  };

  const onPopup = () => {
    setPopup(true);
  };

  const closePopup = () => {
    setPopup(false);
  };

  return (
    <div className="container mtm-confirm-container">
      <div className="row">
        <div className="col-12">
          <h1 className="text-center mb-4 mb-md-5">MADE TO ORDER</h1>
          <p className="text-center">Confirm</p>
          <hr style={hrMainStyle} />
        </div>
      </div>
      <ConfirmRow title={'FABRIC'}>
        <div className="row">
          <div className="col-5 col-md-3 d-flex align-items-center">
            {fabricName}
          </div>
          <div className="col-4 col-md-2 mtm-customizes-row__image">
            <img src={fabricImg} />
          </div>
        </div>
      </ConfirmRow>
      <hr className="mt-3" />
      <ConfirmRow title={'BODY'} isPrimaryHeader={false}>
        <div className="row">
          <div className="col">
            { buttonDownCollar == 'true' ? (
              'For Button Down Collar / '
              ) : (
              'For Non-Button Down Collar / '
              )
            }
            {bodyName}
          </div>
        </div>
      </ConfirmRow>
      <hr className="mt-3" />
      {customizes.collar && (
        <>
          <ConfirmRow title={'COLLARS'}>
            <div className="row">
              <div className="col-5 col-md-3 d-flex align-items-center">
                {customizes.collar.label}
              </div>
              <div className="col-4 col-md-2 mtm-customizes-row__image">
                <img src={customizes.collar.img} />
              </div>
            </div>
          </ConfirmRow>
          <hr className="mt-3" />
        </>
      )}
      {customizes.cuffs && (
        <>
          <ConfirmRow title={'CUFFS'}>
            <div className="row">
              <div className="col-5 col-md-3 d-flex align-items-center">
                {customizes.cuffs.label}
              </div>
              <div className="col-4 col-md-2 mtm-customizes-row__image">
                <img src={customizes.cuffs.img} />
              </div>
            </div>
          </ConfirmRow>
          <hr className="mt-3" />
        </>
      )}
      {customizes.plackets && (
        <>
          <ConfirmRow title={'PLACKETS'}>
            <div className="row">
              <div className="col-5 col-md-3 d-flex align-items-center">
                {customizes.plackets.label}
              </div>
              <div className="col-4 col-md-2 mtm-customizes-row__image">
                <img src={customizes.plackets.img} />
              </div>
            </div>
          </ConfirmRow>
          <hr className="mt-3" />
        </>
      )}
      {customizes.pocket && (
        <>
          <ConfirmRow title={'POCKETS'}>
            <div className="row">
              <div className="col-5 col-md-3 d-flex align-items-center">
                {customizes.pocket.label}
              </div>
              <div className="col-4 col-md-2 mtm-customizes-row__image">
                <img src={customizes.pocket.img} />
              </div>
            </div>
          </ConfirmRow>
          <hr className="mt-3" />
        </>
      )}
      {customizes.button && (
        <>
          <ConfirmRow title={'BUTTON'}>
            <div className="row">
              <div className="col-5 col-md-3 d-flex align-items-center">
                {customizes.button.label}
              </div>
              <div className="col-4 col-md-2 mtm-customizes-row__image">
                <img src={customizes.button.img} />
              </div>
            </div>
          </ConfirmRow>
          <hr className="mt-3" />
        </>
      )}
      <ConfirmRow title={'SIZE'} bodyAlignCenter={false}>
        {customizes.sizes.base && (
          <>
            <ConfirmRow title={'Base Size'} isPrimaryHeader={false}>
              {customizes.sizes.base.label}
            </ConfirmRow>
            <hr className="mt-3" />
          </>
        )}
        {customizes.sizes.chest_size && (
          <>
            <ConfirmRow title={'Chest Size'} isPrimaryHeader={false}>
              {customizes.sizes.chest_size.label}cm &nbsp;(
              {toInch(customizes.sizes.chest_size.label)}inch)
            </ConfirmRow>
            <hr className="mt-3" />
          </>
        )}
        {customizes.sizes.collar_size && (
          <>
            <ConfirmRow title={'Collar Size'} isPrimaryHeader={false}>
              {customizes.sizes.collar_size.label}cm &nbsp;(
              {toInch(customizes.sizes.collar_size.label)}inch)
            </ConfirmRow>
            <hr className="mt-3" />
          </>
        )}
        {customizes.sizes.body_length && (
          <>
            <ConfirmRow title={'Body Length'} isPrimaryHeader={false}>
              {customizes.sizes.body_length.label}cm &nbsp;(
              {toInch(customizes.sizes.body_length.label)}inch)
            </ConfirmRow>
            <hr className="mt-3" />
          </>
        )}
        {customizes.sizes.sleeve_length_left &&
          customizes.sizes.sleeve_length_right && (
            <>
              <ConfirmRow title={'Sleeve Length'} isPrimaryHeader={false}>
                <div className="row">
                  <p className="col-12">
                    Left {customizes.sizes.sleeve_length_left.label}cm &nbsp;(
                    {toInch(customizes.sizes.sleeve_length_left.label)}inch)
                  </p>
                  <p className="col-12">
                    Right {customizes.sizes.sleeve_length_right.label}cm &nbsp;(
                    {toInch(customizes.sizes.sleeve_length_right.label)}inch)
                  </p>
                </div>
              </ConfirmRow>
              <hr className="mt-3" />
            </>
          )}
        {/* NOTE: Monograms と Label の非表示によるコメントアウト
        {customizes.sizes.cuffs_width_left &&
          customizes.sizes.cuffs_width_right && (
            <>
              <ConfirmRow title={'Cuffs Width'} isPrimaryHeader={false}>
                <div className="row">
                  <p className="col-12">
                    Left {customizes.sizes.cuffs_width_left.label}cm &nbsp;(
                    {toInch(customizes.sizes.cuffs_width_left.label)}inch)
                  </p>
                  <p className="col-12">
                    Right {customizes.sizes.cuffs_width_right.label}cm &nbsp;(
                    {toInch(customizes.sizes.cuffs_width_right.label)}inch)
                  </p>
                </div>
              </ConfirmRow>
              <hr className="mt-3" />
            </>
          )}
        {customizes.sizes.waist_size && (
          <>
            <ConfirmRow title={'Waist'} isPrimaryHeader={false}>
              {customizes.sizes.waist_size.label}cm &nbsp;(
              {toInch(customizes.sizes.waist_size.label)}inch)
            </ConfirmRow>
            <hr className="mt-3" />
          </>
        )}
        {customizes.sizes.yoke_size && (
          <>
            <ConfirmRow title={'Yoke'} isPrimaryHeader={false}>
              {customizes.sizes.yoke_size.label}cm
              &nbsp;({toInch(customizes.sizes.yoke_size.label)}inch)
            </ConfirmRow>
            <hr className="mt-3" />
          </>
        )}
        {customizes.sizes.sleeve_width && (
          <>
            <ConfirmRow title={'Sleeve Width'} isPrimaryHeader={false}>
              {customizes.sizes.sleeve_width.label}cm
              &nbsp;({toInch(customizes.sizes.sleeve_width.label)}inch)
            </ConfirmRow>
          </>
        )}
        */}
      </ConfirmRow>
      <hr className="mt-3" />
      {/* NOTE: Monograms と Label の非表示によるコメントアウト
      <ConfirmRow title={'MONOGRAMS'} bodyAlignCenter={false}>
        {!customizes.embroideryOptions.embroidery.value ? (
          <div className="row">
            <div className="col d-flex align-items-center">
              Without Embroidery
            </div>
          </div>
        ) : (
          <>
            {customizes.embroideryOptions.embroidery_color && (
              <>
                <ConfirmRow title={'COLORS'}>
                  <div className="row">
                    <div className="col-5 col-md-3 d-flex align-items-center">
                      {customizes.embroideryOptions.embroidery_color.value}
                    </div>
                    <div className="col-4 col-md-2 mtm-customizes-row__image">
                      <img
                        src={customizes.embroideryOptions.embroidery_color.img}
                        alt={
                          customizes.embroideryOptions.embroidery_color.value
                        }
                      />
                    </div>
                  </div>
                </ConfirmRow>
                <hr className="mt-3" />
              </>
            )}
            {customizes.embroideryOptions.embroidery_type && (
              <>
                <ConfirmRow title={'FONTS'}>
                  <div className="row">
                    <div className="col-5 col-md-3 d-flex align-items-center">
                      {customizes.embroideryOptions.embroidery_type.value}
                    </div>
                    <div className="col-3 col-md-2 mtm-customizes-row__image">
                      <img
                        src={customizes.embroideryOptions.embroidery_type.img}
                        alt={customizes.embroideryOptions.embroidery_type.value}
                      />
                    </div>
                  </div>
                </ConfirmRow>
                <hr className="mt-3" />
              </>
            )}
            <ConfirmRow title={'PLACEMENT'} bodyAlignCenter={false}>
              {customizes.embroideryOptions.embroidery_place && (
                <>
                  <ConfirmRow title={'Location'}>
                    {customizes.embroideryOptions.embroidery_place.value}
                    &nbsp;
                    <img
                      className="col-7 mtm--row_embroidery--img pc"
                      src={embroideryImage}
                      alt="mtm-embroidery"
                    />
                    <img
                      className="w-100 mtm--row_embroidery--img sp"
                      src={embroiderySpImage}
                      alt="mtm-embroidery"
                    />
                  </ConfirmRow>
                  <hr className="mt-3" />
                </>
              )}
              {customizes.embroideryOptions.embroidery_format && (
                <>
                  <ConfirmRow title={'Format'}>
                    {customizes.embroideryOptions.embroidery_format.value}
                  </ConfirmRow>
                  <hr className="mt-3" />
                </>
              )}
              {customizes.embroideryOptions.embroidery_initial && (
                <>
                  <ConfirmRow title={'Text'}>
                    {customizes.embroideryOptions.embroidery_initial.value}
                  </ConfirmRow>
                </>
              )}
            </ConfirmRow>
          </>
        )}
      </ConfirmRow>
      <hr className="mt-3" />
      <ConfirmRow title={'LABEL'}>
        <div className="row">
          {customizes.brand_name && customizes.brand_name.label !== '' && (
            <p className="col-12">{customizes.brand_name.label}</p>
          )}
          {customizes.kamakura_name &&
            customizes.kamakura_name.label !== '' && (
              <p className="col-12">{customizes.kamakura_name.label}</p>
            )}
        </div>
      </ConfirmRow>
      */}
      <hr style={hrMainStyle} />
      <div className="row confirmButtons">
        <div className="col-12 col-md-3 offset-md-3 text-center">
          <Button
            isMobile={true}
            isSecondary={true}
            onClick={onPopup}
            label={'Return To Customize'}
          />
        </div>
        <div className="col-12 col-md-3 text-center mb-2 mt-3 mt-md-0">
          <Button
            isMobile={true}
            isSecondary={false}
            onClick={addCart}
            label={'Add To Cart'}
          />
        </div>
        <div className="text-center mt-4">
          <p>
            Once you click "Add to Cart," you cannot edit the detail anymore.<br />
            In order to edit after it is being added to the cart, you will need to start from the beginning.
          </p>
        </div>
      </div>
      {popup && (
        <div className="confirmError popup_error">
          <div className="popup_error_bg" onClick={closePopup}></div>
          <div className="popup_error_content">
            <div className="popup_error_close" onClick={closePopup}></div>
            <div className="popup_error_heading">
              <img src={cautionImg} />
              <p>Caution</p>
            </div>
            <div className="popup_error_text">
              <p>
                Please note that once you return to the Customize Selection
                screen and change same of tha items, the onces cannot be
                automatically deselected.
              </p>
            </div>
            <div className="row justify-content-center">
              <div className="col-12 col-md-5 text-center">
                <Button
                  isMobile={true}
                  isSecondary={true}
                  onClick={onClickReturn}
                  label={'Return To Customize'}
                />
              </div>
              <div className="col-12 col-md-5 text-center">
                <Button
                  isMobile={true}
                  isSecondary={false}
                  onClick={addCart}
                  label={'Add To Cart'}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomizeConfirm;
